import { MultipleChoiceOption } from '../multiple-choice.constants';

export function isOptionCorrect({
  showAnswer,
  isOptionSelected,
  hasAnswered,
  option,
}: {
  showAnswer: boolean;
  isOptionSelected: boolean;
  option: MultipleChoiceOption;
  hasAnswered: boolean;
}) {
  if (!showAnswer || !hasAnswered) {
    return undefined;
  }

  return isOptionSelected && option.correctAnswerBoolean;
}

export function isOptionIncorrect({
  showAnswer,
  isOptionSelected,
  hasAnswered,
  option,
}: {
  showAnswer: boolean;
  isOptionSelected: boolean;
  option: MultipleChoiceOption;
  hasAnswered: boolean;
}) {
  if (!showAnswer || !hasAnswered) {
    return undefined;
  }

  return isOptionSelected && !option.correctAnswerBoolean;
}

export function getOptionStatus({
  showAnswer,
  isOptionSelected,
  option,
  hasAnswered,
}: {
  showAnswer: boolean;
  isOptionSelected: boolean;
  option: MultipleChoiceOption;
  hasAnswered: boolean;
}) {
  return {
    isCorrect: isOptionCorrect({
      showAnswer,
      isOptionSelected,
      option,
      hasAnswered,
    }),
    isIncorrect: isOptionIncorrect({
      showAnswer,
      isOptionSelected,
      option,
      hasAnswered,
    }),
    isSelected: isOptionSelected,
  };
}
